import { apiPost } from "../baseApi";

export const logout = async () => {
  try {
    const response = await apiPost("_logout");
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
